module.exports = __webpack_public_path__ + "img/newmember_limited_time@2x.beed4428.png";